var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegionUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "middle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -0.75H26V18.75H0V-0.75Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.1665V12.7915H26V11.1665H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.1455V15.7705H26V14.1455H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.20801V6.83301H26V5.20801H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.125V18.75H26V17.125H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.1875V9.8125H26V8.1875H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -0.75V0.875H26V-0.75H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.229V3.854H26V2.229H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 82",
    y: -0.75,
    width: 16.25,
    height: 10.5625,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64924 1.63718L4.05946 2.05065L4.25857 1.31484L3.73474 0.848539H4.41894L4.64841 0.248047L4.91749 0.848539H5.50075L5.04247 1.31484L5.21988 2.05065L4.64924 1.63718ZM1.39927 1.63736L0.809496 2.05083L1.00861 1.31503L0.484779 0.848722H1.16898L1.39845 0.24823L1.66753 0.848722H2.25078L1.7925 1.31503L1.96992 2.05083L1.39927 1.63736ZM7.30946 2.05065L7.89924 1.63718L8.46988 2.05065L8.29247 1.31484L8.75075 0.848539H8.16749L7.89841 0.248047L7.66894 0.848539H6.98474L7.50857 1.31484L7.30946 2.05065ZM11.1492 1.63718L10.5595 2.05065L10.7586 1.31484L10.2347 0.848539H10.9189L11.1484 0.248047L11.4175 0.848539H12.0007L11.5425 1.31484L11.7199 2.05065L11.1492 1.63718ZM0.809458 5.30065L1.39924 4.88718L1.96988 5.30065L1.79247 4.56484L2.25075 4.09854H1.66749L1.39841 3.49805L1.16894 4.09854H0.484741L1.00857 4.56484L0.809458 5.30065ZM4.64924 4.88718L4.05946 5.30065L4.25857 4.56484L3.73474 4.09854H4.41894L4.64841 3.49805L4.91749 4.09854H5.50075L5.04247 4.56484L5.21988 5.30065L4.64924 4.88718ZM7.30946 5.30065L7.89924 4.88718L8.46988 5.30065L8.29247 4.56484L8.75075 4.09854H8.16749L7.89841 3.49805L7.66894 4.09854H6.98474L7.50857 4.56484L7.30946 5.30065ZM11.1492 4.88718L10.5595 5.30065L10.7586 4.56484L10.2347 4.09854H10.9189L11.1484 3.49805L11.4175 4.09854H12.0007L11.5425 4.56484L11.7199 5.30065L11.1492 4.88718ZM0.809458 8.55065L1.39924 8.13718L1.96988 8.55065L1.79247 7.81484L2.25075 7.34854H1.66749L1.39841 6.74805L1.16894 7.34854H0.484741L1.00857 7.81484L0.809458 8.55065ZM4.64924 8.13718L4.05946 8.55065L4.25857 7.81484L3.73474 7.34854H4.41894L4.64841 6.74805L4.91749 7.34854H5.50075L5.04247 7.81484L5.21988 8.55065L4.64924 8.13718ZM7.30946 8.55065L7.89924 8.13718L8.46988 8.55065L8.29247 7.81484L8.75075 7.34854H8.16749L7.89841 6.74805L7.66894 7.34854H6.98474L7.50857 7.81484L7.30946 8.55065ZM11.1492 8.13718L10.5595 8.55065L10.7586 7.81484L10.2347 7.34854H10.9189L11.1484 6.74805L11.4175 7.34854H12.0007L11.5425 7.81484L11.7199 8.55065L11.1492 8.13718ZM13.8095 2.05065L14.3992 1.63718L14.9699 2.05065L14.7925 1.31484L15.2507 0.848539H14.6675L14.3984 0.248047L14.1689 0.848539H13.4847L14.0086 1.31484L13.8095 2.05065ZM14.3992 4.88718L13.8095 5.30065L14.0086 4.56484L13.4847 4.09854H14.1689L14.3984 3.49805L14.6675 4.09854H15.2507L14.7925 4.56484L14.9699 5.30065L14.3992 4.88718ZM13.8095 8.55065L14.3992 8.13718L14.9699 8.55065L14.7925 7.81484L15.2507 7.34854H14.6675L14.3984 6.74805L14.1689 7.34854H13.4847L14.0086 7.81484L13.8095 8.55065ZM3.02424 3.26218L2.43446 3.67565L2.63357 2.93984L2.10974 2.47354H2.79394L3.02341 1.87305L3.29249 2.47354H3.87575L3.41747 2.93984L3.59488 3.67565L3.02424 3.26218ZM5.68446 3.67565L6.27424 3.26218L6.84488 3.67565L6.66747 2.93984L7.12575 2.47354H6.54249L6.27341 1.87305L6.04394 2.47354H5.35974L5.88357 2.93984L5.68446 3.67565ZM9.52423 3.26218L8.93446 3.67565L9.13357 2.93984L8.60974 2.47354H9.29394L9.52341 1.87305L9.79249 2.47354H10.3757L9.91747 2.93984L10.0949 3.67565L9.52423 3.26218ZM2.43446 6.92565L3.02424 6.51218L3.59488 6.92565L3.41747 6.18984L3.87575 5.72354H3.29249L3.02341 5.12305L2.79394 5.72354H2.10974L2.63357 6.18984L2.43446 6.92565ZM6.27424 6.51218L5.68446 6.92565L5.88357 6.18984L5.35974 5.72354H6.04394L6.27341 5.12305L6.54249 5.72354H7.12575L6.66747 6.18984L6.84488 6.92565L6.27424 6.51218ZM8.93446 6.92565L9.52423 6.51218L10.0949 6.92565L9.91747 6.18984L10.3757 5.72354H9.79249L9.52341 5.12305L9.29394 5.72354H8.60974L9.13357 6.18984L8.93446 6.92565ZM12.7742 3.26218L12.1845 3.67565L12.3836 2.93984L11.8597 2.47354H12.5439L12.7734 1.87305L13.0425 2.47354H13.6257L13.1675 2.93984L13.3449 3.67565L12.7742 3.26218ZM12.1845 6.92565L12.7742 6.51218L13.3449 6.92565L13.1675 6.18984L13.6257 5.72354H13.0425L12.7734 5.12305L12.5439 5.72354H11.8597L12.3836 6.18984L12.1845 6.92565Z",
    fill: "#F7FCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionUs);
export default __webpack_public_path__ + "static/media/region-us.aa233d5b57dac4fc842903a8598abd3c.svg";
export { ForwardRef as ReactComponent };